export default __webpack_public_path__ + "static/media/rotate-ccw.19218ecc.svg";